<template>
  <div class="container">
    <div class="header">
      <div class="w1250">
        <z-header></z-header>
      </div>
    </div>
    <div class="main w1200" v-if="pageInfo.hasOwnProperty('pageInfo')">
      <z-breadcrumb v-if="pageInfo.pageInfo.hasOwnProperty('breadcrumbs')" :options="pageInfo.pageInfo.breadcrumbs"></z-breadcrumb>
      <form-card v-if="pageInfo.hasOwnProperty('form')" ref="form" class="form-card" v-on:cascader_change="cascaderChange" :form-data="pageInfo.form.field" :form-inputs="pageInfo.form.form_field" :form-rules="pageInfo.form.rules" :id="pageInfo.form.id" :options="pageInfo.form.options" :name="pageInfo.form.name" v-on:formEvent="formEvent">
        <div slot="formHeader" class="bzBg">
          <div class="bzDiv">
            <div class="bzCon fL">
              <div class="bzNum fL marR8 marT success">
                <div class=" fL icon-circle-open marR8 ">1</div>
                填写基本信息
              </div>
              <div class="line fL marR8">----------</div>
              <div class="bzNum fL marR8 marT close">
                <div class=" fL icon-circle-close marR8">2</div>
                上传资质信息
              </div>
            </div>
            <div class="bzBtn fL">
              <el-button class="fL marR20" @click="cancelForm()">取消</el-button>
              <el-button type="primary" @click="submitForm(pageInfo.form.options.ref)">下一步，上传资质
              </el-button>
            </div>
          </div>
          <div slot="formTips" class="form-tips">
            <div v-html="pageInfo.form.packageFillingRequirements"></div>
          </div>
          <z-alert :tag-msg="pageInfo.pageInfo.tag_msg"></z-alert>
        </div>
        <div slot="cascaderContent" v-html="industry_tips" v-if="industry_tips" class="tipTxt">
        </div>
      </form-card>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import FormCard from "@/components/form/Form";
import { getData, saveData } from "../utils/utils";
import qs from 'qs';
export default {
  name: "Base",
  components: {
    "form-card": FormCard
  },
  data: function() {
    return {
      pageInfo: {},
      options: {},
      formValidate: false,
      formData: {},
      tagMsg: {},
      industry_tips: "",
      isDisable: true,
    };
  },
  computed: {
    isBrandZZFlag: function () {
      return window.location.host.includes('brand')
    },
  },
  watch: {
    pageInfo: function(newData, oldData) {}
  },
  created: function() {
    let packageId = this.$route.params.package_id || 0;
    let params = {};
    if (this.$route.query["loginParam"]) {
      params["loginParam"] = this.$route.query["loginParam"];
    }
    if (this.$route.query["customer_id"]) {
      params["customer_id"] = this.$route.query["customer_id"];
    }
    if (this.$route.query['clientId']) {
      params['clientId'] = this.$route.query['clientId']
    }
    if (packageId === 0) {
      getData(
        this.isBrandZZFlag ? "/api/package/crm/getTemp":"/api/package/getTemp",
        params,
        res => {
          if (res.code == 0 && res.data && res.data.packageId) {
            let url = "/qulification/license/" + res.data.packageId;
            let urlHash = {}
            if (this.$route.query['customer_id']) {
              urlHash['customer_id'] = this.$route.query['customer_id']
            }
            if (this.$route.query['clientId']) {
              urlHash['clientId'] = this.$route.query['clientId']
            }
            if (this.$route.query['loginParam']) {
              urlHash['loginParam'] = this.$route.query['loginParam']
            }
            url = Object.keys(urlHash).length > 0 ? url + `?${qs.stringify(urlHash)}` : url
            this.$router.push(url);
          }
        },
        eres => {},
        false
      );
      getData(this.isBrandZZFlag ? "/api/package/crm/addFirst": "/api/package/addFirst", params, res => {
        if (res.code == 0) {
          this.pageInfo = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      });
    } else {
      params["package_id"] = packageId;
      getData(this.isBrandZZFlag? "/api/package/crm/updateFirst" : "/api/package/updateFirst", params, res => {
        if (res.code == 0) {
          this.pageInfo = res.data;
        } else {
          let url = "/";
          let urlHash = {}
          if (this.$route.query['customer_id']) {
            urlHash['customer_id'] = this.$route.query['customer_id']
          }
          if (this.$route.query['clientId']) {
            urlHash['clientId'] = this.$route.query['clientId']
          }
          if (this.$route.query['loginParam']) {
            urlHash['loginParam'] = this.$route.query['loginParam']
          }
          url = Object.keys(urlHash).length > 0 ? url + `?${qs.stringify(urlHash)}` : url
          this.$router.push(url);
        }
      });
    }
  },
  mounted: function() {},
  methods: {
    submitForm: function(formName) {
      this.$refs["form"].$emit("validate");
      if (this.pageInfo.hasOwnProperty("form")) {
        if (this.formValidate && this.isDisable) {
          this.isDisable = false;
          saveData(
            this.pageInfo.form.options.action,
            this.formData,
            res => {
              let url = "/qulification/license/" + res.data;
              let urlHash = {}
              if (this.$route.query['customer_id']) {
                urlHash['customer_id'] = this.$route.query['customer_id']
              }
              if (this.$route.query['clientId']) {
                urlHash['clientId'] = this.$route.query['clientId']
              }
              if (this.$route.query['loginParam']) {
                urlHash['loginParam'] = this.$route.query['loginParam']
              }
              url = Object.keys(urlHash).length > 0 ? url + `?${qs.stringify(urlHash)}` : url
              this.$router.push(url);
            },
            errs => {
              var params = {}
              if (this.$route.query['loginParam']) {
                params['loginParam'] = this.$route.query['loginParam']
              }
              getData(this.isBrandZZFlag ? "/api/token/crm/getToken" : "/api/token/getToken", params, res => {
                if (res.code == 0) {
                  this.pageInfo.form.field.token = res.data;
                }
              });
            }
          );
          setTimeout(() => {
            this.isDisable = true;
          }, 500);
          return false;
        }
      }
      return false;
    },
    formEvent: function(form) {
      this.formValidate = form.valid;
      this.formData = form.data;
      if (this.$route.query["customer_id"]) {
        this.formData["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        this.formData["clientId"] = this.$route.query["clientId"];
      }
      if (this.$route.query["loginParam"]) {
        this.formData["loginParam"] = this.$route.query["loginParam"];
      }
    },
    cancelForm: function() {
      let url = "/";
      if (this.$route.query["customer_id"]) {
        url = url + "?customer_id=" + this.$route.query["customer_id"];
      }
      if (this.$route.query["loginParam"]) {
        url = url + "?loginParam=" + this.$route.query["loginParam"];
      }
      this.$router.push(url);
    },
    cascaderChange: function(event, inputCard) {
      let items = inputCard.items;
      if (items) {
        items.forEach(e => {
          if (e.value === event[0]) {
            let childItems = e.children;
            childItems.forEach(ce => {
              if (ce.value === event[1]) {
                this.industry_tips = ce.tip;
              }
            });
          }
        });
      } else {
        this.$message.warning("系统异常");
        let url = "/";
        let urlHash = {}
        if (this.$route.query['customer_id']) {
          urlHash['customer_id'] = this.$route.query['customer_id']
        }
        if (this.$route.query['clientId']) {
          urlHash['clientId'] = this.$route.query['clientId']
        }
        if (this.$route.query['loginParam']) {
          urlHash['loginParam'] = this.$route.query['loginParam']
        }
        url = Object.keys(urlHash).length > 0 ? url + `?${qs.stringify(urlHash)}` : url
        this.$router.push(url);
      }
    }
  }
};
</script>
<style>
.form-card input {
  width: 460px;
}

.form-card textarea {
  width: 460px;
}

.form-tips{
  position: absolute;
  top: 155px;
  left: 520px;
  z-index: 1;
  color: red;
  white-space: pre-wrap;
}

.form-tips p{
  padding-left: 5px;
  padding-right: 20px;
}

.success {
  color: #2a60e4;
}

.close {
  color: #8f98b9;
}

.line {
  color: #e3e7f1;
  line-height: 38px;
}

.bzDiv {
  overflow: hidden;
  padding-bottom: 5px;
}

.bzCon {
  width: 918px;
}

.bzBtn {
  width: 282px;
}

.tipTxt {
  padding-top: 30px;
  padding-left: 10px;
  padding-right: 57px;
  padding-bottom: 30px;
  font-size: 14px;
  color: #2e334a;
  line-height: 18px;
}

.tipTxt a {
  text-decoration: none;
}

.tipTxt ul li {
  list-style: none;
  padding-bottom: 5px;
  padding-top: 5px;
}

.bzBg {
  background: #f9f9f9;
  padding-bottom: 10px;
}

.icon-circle-open {
  background: #2a60e4;
  width: 24px;
  height: 24px;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  border-radius: 50%;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0.4px;
  line-height: 24px;
}

.icon-circle-close {
  background: #8f98b9;
  width: 24px;
  height: 24px;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  border-radius: 50%;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  line-height: 24px;
}

.default-error {
  border-color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/components/Base.vue